// @flow
import { TiposActionTypes } from './constants';

type TiposAction = { type: string, payload: {} | string };

// common success
export const tiposApiResponseSuccess = (actionType: string, data: any): TiposAction => ({
    type: TiposActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});
// common error
export const tiposApiResponseError = (actionType: string, error: string): TiposAction => ({
    type: TiposActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const listTipos = (): TiposAction => ({
    type: TiposActionTypes.LIST_TIPOS,
    payload: {},
});

export const getTipo = (id: string): TiposAction => ({
    type: TiposActionTypes.GET_TIPO,
    payload: { id },
});

export const addTipo = (tipo: any): TiposAction => ({
    type: TiposActionTypes.ADD_TIPO,
    payload: tipo
})
export const updateTipo = (tipo: any): TiposAction => ({
    type: TiposActionTypes.UPDATE_TIPO,
    payload: tipo
})
export const deleteTipo = (id: string): TiposAction => ({
    type: TiposActionTypes.DELETE_TIPO,
    payload: { id }
})

export const resetTipos = (): TiposAction => ({
    type: TiposActionTypes.RESET,
    payload: {},
});

